import { MenuPageDesignation, UserRight } from '@biteinc/enums';
export const menuPageSchema = {
    displayName: 'menu page',
    type: 'object',
    fields: {
        _id: {
            type: 'mongoId',
            required: true,
            isHidden: true,
        },
        i9nId: {
            type: 'keyString',
            isHidden: true,
        },
        name: {
            type: 'shortString',
            required: true,
            isHidden: true,
            canHaveLocalizationOverrides: true,
        },
        description: {
            type: 'shortString',
            canHaveLocalizationOverrides: true,
        },
        pages: {
            type: 'array',
            elementType: 'object',
            elementSubtype: 'MenuPage',
            isHidden: true,
        },
        associatedVendorId: {
            type: 'keyString',
            displayName: 'Associated Vendor ID',
            writeRight: UserRight.ManageMenu,
        },
        showQuickNav: {
            type: 'bool',
            displayName: 'Show Quick Nav Buttons',
            tooltip: {
                text: 'Show buttons at the top of the page that let the user jump between sections. Recommended for pages with many sections.',
            },
            writeRight: UserRight.ManageMenu,
        },
        designation: {
            type: 'stringEnum',
            enum: MenuPageDesignation,
            required: true,
            defaultValue: MenuPageDesignation.Regular,
            ui: 'dropdown',
            writeRight: UserRight.ManageMenu,
        },
        images: {
            type: 'array',
            elementType: 'object',
            elementSubtype: 'Image',
            elementUniqueIdFieldName: 'origUrl',
            maxCount: 1,
            forceCrop: true,
            size: {
                width: 1536,
                height: 400,
            },
            writeRight: UserRight.ManageMenu,
        },
        pageNavigationImages: {
            type: 'array',
            displayName: 'Page Navigation button background image',
            elementType: 'object',
            elementSubtype: 'Image',
            elementUniqueIdFieldName: 'origUrl',
            canHaveLocalizationOverrides: true,
            maxCount: 1,
            keepAspectRatio: 'contain',
            size: {
                width: 1200,
                height: 1200,
            },
            writeRight: UserRight.ManageMenu,
            tooltip: {
                text: 'This image will be used as background of page navigation section.',
            },
        },
        pageBannerImages: {
            type: 'array',
            displayName: 'Page Banner Image',
            elementType: 'object',
            elementSubtype: 'Image',
            elementUniqueIdFieldName: 'origUrl',
            canHaveLocalizationOverrides: true,
            maxCount: 1,
            keepAspectRatio: 'fit-width',
            size: {
                width: 1000,
                height: 400,
            },
            writeRight: UserRight.ManageMenu,
            tooltip: {
                text: 'This image is used as a banner that goes at the beginning of a page (Vitrine only).',
            },
        },
        pageBackgroundImages: {
            type: 'array',
            displayName: 'Page Background Image',
            elementType: 'object',
            elementSubtype: 'Image',
            elementUniqueIdFieldName: 'origUrl',
            canHaveLocalizationOverrides: true,
            maxCount: 1,
            keepAspectRatio: 'contain',
            size: {
                width: 1080,
                height: 1920,
            },
            writeRight: UserRight.ManageMenu,
            tooltip: {
                text: `This image is used as a background for a page and all it's subpages.`,
            },
        },
        sectionIds: {
            type: 'array',
            elementType: 'mongoId',
            displayName: 'Menu Sections',
            ui: 'table',
            placeholder: 'Select Menu Section',
            writeRight: UserRight.ManageMenu,
        },
        i9nSectionIds: {
            type: 'array',
            elementType: 'keyString',
            isReadOnly: true,
            isHidden: true,
        },
        colorScheme: {
            type: 'keyString',
            displayName: 'Color Scheme',
            writeRight: UserRight.ManageMenu,
        },
    },
};
//# sourceMappingURL=menu_page_schema.js.map